<template>
    <div>
        <v-container>
            <v-select :items="items" v-model="catagory" label="Type" />
            <v-text-field v-show="catagory" label="Subject" v-model="subject" />
            <v-label v-if="catagory">Body</v-label>
            <vue-editor v-show="catagory" v-model="msgbody" />
            <br />
            <v-btn :loading="loading" @click="submit">Submit</v-btn>
            <v-dialog v-model="dialog" width="500">
                <v-alert>
                    Updated Successfully.
                    <v-divider></v-divider>
                    <v-btn color="primary" text @click="dialog = false">
                        Ok
                    </v-btn>
                </v-alert>
            </v-dialog>
        </v-container>
    </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import store from "../../../../store";
import axios from "axios";
export default {
    components: {
        VueEditor
    },
    data: function() {
        return {
            store: store,
            msgbody: "",
            subject: "",
            loading: false,
            dialog: false,
            catagory: null,
            items: ["Welcome", "New Schedule", "Password Reset"]
        };
    },
    created: function() {
        if (this.store.state.user.role == "user")
            this.$router.replace("/dashboard");
        if (!this.store.state.isLoggedIn) this.$router.replace("/login");
    },
    methods: {
        submit: async function() {
            this.loading = true;
            let Formdata = new FormData();
            Formdata.set("subject", this.subject);
            Formdata.set("body", this.msgbody);
            Formdata.set("catagory", this.items.indexOf(this.catagory));

            var config = {
                url: `${this.store.state.baseURL}updatemail`,
                method: "post",
                headers: {
                    "Content-Type": "application/form-data;charset=utf-8",
                    "Access-Control-Allow-Origin": "*",
                    Accept: "*/*"
                },
                data: Formdata
            };

            try {
                await axios(config);
                this.dialog = true;
            } catch (err) {
                console.log(err);
            }
            this.loading = false;
        }
    },
    watch: {
        async catagory(val) {
            this.loading = true;
            try {
                var resp = await axios.get(
                    `${this.store.state.baseURL}mailbody/${this.items.indexOf(
                        val
                    )}`
                );
                this.msgbody = resp.data.Mail[0].body;
                this.subject = resp.data.Mail[0].subject;
                this.loading = false;
            } catch (err) {
                this.loading = false;
                console.log(err);
            }
        }
    }
};
</script>

<style></style>
